module.exports = __webpack_public_path__ + "img/S-WEB-Goal-14.ba931e31.png";